import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import AssessmentScoresByCategoryView from "./AssessmentScoresByCategoryView";
import { FETCH_ASSESSMENT_SCORE_BY_CATEGORY } from "./graphql";
import SupplierAchievements from "./SupplierAchievements";

const AssessmentReports = () => {
  const name = "Assessment 2025";

  const { loading, error, data } = useQuery(
    FETCH_ASSESSMENT_SCORE_BY_CATEGORY,
    { variables: { name } },
  );

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const res = JSON.parse(data.assessmentScoresByCategory).map((i) => {
    const keys = Object.keys(i).filter((key) => key !== "supplier");
    let avg = keys.reduce((acc, key) => acc + i[key], 0) / keys.length;
    avg = Math.round(avg * 100) / 100;
    return { ...i, "Average Score": avg };
  });

  console.log("res", res);

  return (
    <Page
      title="ESG Report"
      subtitle="Note: This page is used for ESG Assessment Report 2024 only. To use it for other category, we will need to adjust the code behind the scene."
      backTo="./.."
    >
      <div className="p-8 grid gap-8">
        <AssessmentScoresByCategoryView data={res} name={name} />
        <SupplierAchievements />
      </div>
    </Page>
  );
};

export default AssessmentReports;
